<template>
  <span>
    <router-link :to="{name: 'reservations.view', params: {id: reservationUuid}}" v-if="$hasPermission('view_auction')">
              {{ lotNo }}</router-link>
    <span v-else>
      {{ lotNo }}
    </span>
  </span>
</template>

<script>

  export default {
    name: "LinkedLotNo",
    props: ['lotNo', 'reservationUuid'],
  }
</script>

<style scoped>

</style>
